module.exports = __webpack_public_path__ + "static/img_6-99a4eb4ba507d244ac71269e6d502a19.png";